
const validate = (props) => {
    const errors = {}

    if (!props.password) {
        errors.password = {
            ar: ' يرجى ادخال كلمة المرور',
            en: 'Enter your password'
        }
    }
    if (!props.newPassword) {
        errors.newPassword = {
            ar: ' يرجى ادخال كلمة المرور',
            en: 'Enter your password'
        }
    }
    if (props.newPassword !== props.password) {
        errors.newPassword = {
            ar: 'كلمة المرور غير متطابقة',
            en: 'invalid password'
        }
    }

    return errors
}

export default validate;